<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Амбулаторное обслуживание (для зарубежных пациентов с/без корейским государственным медицинским страхованием)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">Шаг 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Запись на прием</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Визит в Международный медицинский центр.</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Консультация у лечащего врача</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Оплата</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Прохождение обследования и получение лекарств по рецепту</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Запись на прием</h4>
            <p class="depth">
                Обратитесь по тел. +82-2650-5897 <br>
                Эл. почта ewha.rus@gmail.com <br>
                Онлайн, в разделе «Заказать прием» <br>
                Посетите клинику (обратите внимание, что прием в тот же день бывает невозможным)
            </p>
            <h4 class="depth bullet02">Визит в Международный медицинский центр.</h4>
            <p class="depth">
                Прибудьте в Международный медицинский центр, располагающийся на 1-м этаже. Для регистрации вам потребуется предъявить карту вида на жительство или паспорт. Если у вас имеются медицинская карта, результаты анализов или снимки на компакт-диске, рекомендуем прибыть за 10 минут до приема, чтобы загрузить в больничную систему материалы. Вы можете посетить врача, который был вам назначен, воспользовавшись больничным идентификационным номером.
            </p>
            <h4 class="depth bullet02">Консультация у лечащего врача</h4>
            <p class="depth">
                Ваш лечащий врач обсудит с вами план лечения и направит вас к другому специалисту в случае необходимости. Медсестра или координатор Международного медицинского центра окажет вам помощь в планировании диагностических обследований или контрольных приемов.
            </p>
            <h4 class="depth bullet02">Оплата</h4>
            <p class="depth">
                Оплата лечения может быть произведена наличными (корейскими вонами) или кредитной картой. Если вам потребуется произвести обмен валюты, вы можете воспользоваться услугами банка, расположенного на этаже В1 главного здания. Согласно процедурам, утвержденным в нашей больнице, все амбулаторные обследования и терапии, за исключением консультаций, должны оплачиваться до приема у врача. Принесите с собой формы документов международного страхования, если вам необходимо предъявить их в вашу страховую компанию.
            </p>
            <h4 class="depth bullet02">Прохождение обследования и получение лекарств по рецепту</h4>
            <p class="depth">
                После совершения платежа вы можете пройти запланированные обследования. Распечатайте свой рецепт и пройдите в аптеку за получением лекарств.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>